/**
 * The color labels picker is anchored to the indicator and overflows the row it belongs to,
 * so on the last rows it would render outside the scrollable catalog and stay unreachable.
 * Flip it above the indicator only when that gives the options more room than staying below.
 */
const shouldDropColorsUp = ({ openerRect, containerRect, listHeight } = {}) => {
  if (!openerRect || !containerRect || !listHeight) return false;

  const spaceBelow = containerRect.bottom - openerRect.bottom;
  if (spaceBelow >= listHeight) return false;

  const spaceAbove = openerRect.top - containerRect.top;
  return spaceAbove > spaceBelow;
};

export default shouldDropColorsUp;
